export class User {
  constructor(
    public username: string,
    public expiration: Number,
    public token: string) {
  }
}
